// extracted by mini-css-extract-plugin
module.exports = {"section":"section-module--section--1-wrE","infocontainer":"section-module--infocontainer--1gCRX","info":"section-module--info--p2IMd"};